import { call, put, takeLatest } from "redux-saga/effects";
import * as authApis from "../apis/authApi";
import { EMAIL_LOGIN, FORGOT_PASSWORD, GOOGLE_LOGIN, MICROSOFT_LOGIN, RESET_PASSWORD, VERIFY_LOGIN } from "../actions/types";
import { USER_DATA_LOADED } from "../actions/returnType";

export function* googleLoginWorker(action) {
    try {
        const res = yield call(authApis.googleLoginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data });
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* microsoftLoginWorker(action) {
    try {
        const res = yield call(authApis.microsoftLoginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
            yield put({ type: USER_DATA_LOADED, data: res?.data?.data });
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* emailLoginWorker(action) {
    try {
        const res = yield call(authApis.emailLoginApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* forgotPasswordWorker(action) {
    try {
        const res = yield call(authApis.forgotPasswordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* resetPasswordWorker(action) {
    try {
        const res = yield call(authApis.resetPasswordApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* verifyTokenWorker(action) {
    try {
        const res = yield call(authApis.verifyTokenApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/**Watcher functions */

export function* googleLoginWatcher() {
    yield takeLatest(GOOGLE_LOGIN, googleLoginWorker);
}

export function* microsoftLoginWatcher() {
    yield takeLatest(MICROSOFT_LOGIN, microsoftLoginWorker);
}

export function* emailLoginWatcher() {
    yield takeLatest(EMAIL_LOGIN, emailLoginWorker);
}
export function* forgotPasswordWatcher() {
    yield takeLatest(FORGOT_PASSWORD, forgotPasswordWorker);
}

export function* resetPasswordWatcher() {
    yield takeLatest(RESET_PASSWORD, resetPasswordWorker);
}
export function* verifyTokenWatcher() {
    yield takeLatest(VERIFY_LOGIN, verifyTokenWorker);
}